module.exports = __webpack_public_path__ + "img/UT0401.af1be182.png";